import React from 'react';
import BlogsSection from '../components/BlogsSection';
import Footer from '../components/Footer';
import HeroSection from '../components/HeroSection';
import Navbar from '../components/Navbar';
import NewsletterSection from '../components/NewsletterSection';
import AIServicesSection from '../components/services/AIServicesSection';
import CloudInfrastructureSection from '../components/services/CloudInfrastructureSection';
import CyberSecuritySection from '../components/services/CyberSecuritySection';
import ITStaffingSection from '../components/services/ITStaffingSection';
import ProjectServicesSection from '../components/services/ProjectServicesSection';

export default function Home() {
  return (
    <div className="min-h-screen">
      <Navbar />
      <HeroSection />
      <BlogsSection />
      <ITStaffingSection />
      <ProjectServicesSection />
      <CloudInfrastructureSection />
      <AIServicesSection />
      <CyberSecuritySection />
      <NewsletterSection />
      <Footer />
    </div>
  );
}
